module.exports = __webpack_public_path__ + "fonts/fda0a9663a5907c93e18605685d1d782.svg";